'use client';

import { useGoogleTagManagerHandler } from '@/src/components/ui/GoogleTagManagerHandler/useGoogleTagManagerHandler';

export const GoogleTagManagerHandler = () => {
  useGoogleTagManagerHandler();

  return <span></span>;
};
